import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTravelDurationLabelNew } from '../../../../../../components/SearchForm/components/TravelPeriodWidgetNext/hooks/useTravelDurationLabelNext.js';
import { Chip } from '../../../../../../primitives/index.js';
export const ChipItem = ({
  item,
  isActive,
  onClick,
  disabled
}) => {
  const label = useTravelDurationLabelNew({
    minDuration: item?.min,
    maxDuration: item?.max
  });
  return _jsx(Chip, {
    variant: isActive ? 'filled' : 'outlined',
    active: isActive,
    label: label,
    disabled: disabled,
    onClick: () => onClick(item)
  });
};